export default __webpack_public_path__ + "static/media/Gauntlets of the Triumphant.95725809.jpg";